export const LEGAL_CANCELLATION_PROCEDURE: string = `

### <!--= ++sectionIndex -->. Stornierungsverfahren

#### <!--= sectionIndex -->.1 Stornierung über das Muster-Stornierungsformular

Wenn Sie Ihr Abonnement kündigen möchten, können Sie alternativ unser unten bereitgestelltes “Muster-Kündigungsformular” verwenden. Bitte füllen Sie die erforderlichen Felder aus und senden Sie es per E-mail oder Post an uns zurück.

Bitte stellen Sie sicher, dass Sie das Formular korrekt ausfüllen, um eine schnelle Bearbeitung Ihrer Anfrage zu ermöglichen.

<div style="padding: 36px; box-shadow: 0px 4px 11px 0px rgba(0,0,0,0.25); border-radius: 16px;">

**Muster-Widerrufsformular**

*(Füllen Sie dieses Formular aus und senden Sie es nur zurück, wenn Sie vom Vertrag zurücktreten möchten.)*

Zu:
<!-- for (const addressLine of company.address) { -->
<!--= addressLine -->
<!-- } -->

oder,

E-Mail: <!--= company.mail -->

Hiermit erkläre(n) ich/wir (&#42;), dass ich/wir (&#42;) von meinem/unserem (&#42;) Kaufvertrag über die folgenden Waren (&#42;)/der Bereitstellung der folgenden Waren (&#42;) zurücktrete(n). folgender Service (&#42;),

Bestellt am (&#42;)/Erhalten am (&#42;),

Name des/der Verbraucher(s),

Adresse des/der Verbraucher(s),

Unterschrift des/der Verbraucher(s)
*(nur wenn dieses Formular auf Papier übermittelt wird)*

Datum

*(&#42;) Zutreffendes löschen*

</div>
<br>

<!-- if (cancellationPolicy.selfCancellation) { -->

#### <!--= sectionIndex -->.2 <!--= cancellationPolicy.selfCancellation.heading -->

<!-- for (const textLine of cancellationPolicy.selfCancellation.texts) { -->
<!--= textLine -->

<!-- } -->

<!-- } -->
`;
